import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifier"},_vm._l((_vm.localMessagesList),function(message,index){return _c('div',[_c(VAlert,{attrs:{"dense":"","dismissible":"","type":message.priority},on:{"click":function($event){return _vm.dismissAlert(index)}},model:{value:(message.visibility),callback:function ($$v) {_vm.$set(message, "visibility", $$v)},expression:"message.visibility"}},[_vm._v(_vm._s(message.message))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }